import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@workspace/ui/components/tooltip';

type Props = {
  text: string;
  children: React.ReactNode;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
};

export const TooltipComponent = ({ text, children, className, side }: Props) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side ? side : 'top'}
          className={`bg-white w-fit max-w-28 line-clamp-2 md:mb-3 max-h-11 ${className}`}
        >
          <div
            className={`text-center text-gray-text text-xs font-light ${className}`}
          >
            {text}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
